import React, { FC } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { AiOutlineForm } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import CustomSwitch from "global/Switch/Switch";

interface SurveyFormHeaderProps {
  isEditMode: boolean;
  selectedQuestionsCount: number;
  isActive: boolean;
  onActiveChange: (value: boolean) => void;
}

const SurveyFormHeader: FC<SurveyFormHeaderProps> = ({
  isEditMode,
  selectedQuestionsCount,
  isActive,
  onActiveChange,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Top Action */}
      <div className="flex items-center justify-between mb-4">
        <div className="text-xs text-gray-400">
          {isEditMode ? "ویرایش نظرسنجی" : "ایجاد نظرسنجی جدید"}
        </div>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-100 rounded-2xl shadow-sm text-sm font-medium text-gray-600 hover:bg-gray-50 transition"
        >
          <FiArrowLeft size={16} />
          بازگشت
        </button>
      </div>

      {/* Hero Header */}
      <div className="rounded-[28px] bg-gradient-to-l from-[#fde9f1] via-[#fff4f8] to-[#fffafa] border border-pink-100/60 shadow-sm p-5 md:p-7 mb-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-[#7a1b2b] text-white flex items-center justify-center shadow-md">
              <AiOutlineForm size={28} />
            </div>

            <div>
              <h1 className="text-lg md:text-2xl font-extrabold text-gray-800">
                {isEditMode ? "ویرایش فرم نظرسنجی" : "ایجاد فرم نظرسنجی"}
              </h1>
              <p className="text-xs md:text-sm text-gray-500 mt-1">
                اطلاعات فرم را تکمیل کنید و سوالات را با Drag & Drop به نظرسنجی
                اضافه کنید.
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <div className="px-4 py-2 rounded-2xl bg-white/80 border border-white shadow-sm text-sm text-gray-600">
              تعداد سوالات انتخابی:
              <span className="font-extrabold text-[#7a1b2b] mr-2">
                {selectedQuestionsCount}
              </span>
            </div>

            <div className="flex items-center gap-2 px-4 py-2 rounded-2xl bg-white/80 border border-white shadow-sm">
              <span className="text-xs text-gray-500">وضعیت فرم</span>
              <CustomSwitch active={isActive} handleChange={onActiveChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SurveyFormHeader;
